import React from 'react';

import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';

import Home from './pages/Home';

import Appointments from './pages/Appointments';

import Conversations from './pages/Conversations';

import HumanIntervention from './pages/HumanIntervention';

import Leads from './pages/Leads';

import Calls from './pages/Calls';


import RagUpload from './pages/RagUpload';

import VoiceCall from './pages/VoiceCall';

import './engagement-portal.css';

import './theme.css';

import EngagementShell from './layout/EngagementShell';

import { EngagementScopeProvider } from './context/EngagementScope';

import AgentSettings from './pages/AgentSettings';

import Branches from './pages/Branches';

import Services from './pages/Services';

import MyNumber from './pages/MyNumber';

import Automations from './pages/Automations';

import WaAccounts from './pages/WaAccounts';

import WaTemplates from './pages/WaTemplates';

import Offers from './pages/Offers';

import OptedOut from './pages/OptedOut';

import Campaigns from './pages/Campaigns';

import Segments from './pages/Segments';

import CouponOffers from './pages/CouponOffers';

import AdCampaigns from './pages/AdCampaigns';

import InstagramSettings from './pages/InstagramSettings';

import { getEngagementNavRoutes, ENGAGEMENT_REDIRECTS, HQ_SEGMENTS } from './layout/navConfig';
import { getEngagementPortal } from './engagementPortal';

import {

  engagementFirstSegment,

  engagementPath,

  engagementRelativePath,

} from './engagementPaths';



const PAGE_BY_SEGMENT = {

  '': <Home />,

  leads: <Leads />,

  appointments: <Appointments />,

  'ai-docs': <RagUpload />,


  conversations: <Conversations />,

  'human-intervention': <HumanIntervention />,

  'call-records': <Calls />,

  'agent-settings': <AgentSettings />,

  instagram: <InstagramSettings />,

  branches: <Branches />,

  services: <Services />,

  'my-number': <MyNumber />,

  automations: <Automations />,

  'wa-accounts': <WaAccounts />,

  templates: <WaTemplates />,

  offers: <Offers />,

  'opted-out': <OptedOut />,

  campaigns: <Campaigns />,

  segments: <Segments />,

  'coupon-offers': <CouponOffers />,

  'ad-campaigns': <AdCampaigns />,

};



function staffAvailabilityRedirect() {

  return '/naturals/partner/staff-availability';

}



/**

 * Partner + main-app mounts: parent route is `…/engagement/*` but nested <Routes> do not

 * reliably match under React Router v7 — resolve the page from pathname instead.

 */

function EngagementEmbedded() {

  const location = useLocation();

  const portal = getEngagementPortal();

  const navRoutes = getEngagementNavRoutes(portal);

  const rel = engagementRelativePath(location.pathname);

  const segment = engagementFirstSegment(rel);



  if (segment === 'voice-call') {

    return <VoiceCall />;

  }



  if (segment === 'staff' || segment === 'staff-availability' || segment === 'slots') {

    return <Navigate to={staffAvailabilityRedirect()} replace />;

  }



  const redirectTo = ENGAGEMENT_REDIRECTS[segment];

  if (redirectTo) {

    return <Navigate to={engagementPath(redirectTo)} replace />;

  }

  if (
    (segment === 'wa-accounts' || segment === 'branches') &&
    location.pathname.startsWith('/naturals/workspace/engagement')
  ) {
    const next = segment === 'wa-accounts' ? 'accounts' : 'branches';
    return <Navigate to={`/naturals/workspace/whatsapp/${next}`} replace />;
  }



  if (HQ_SEGMENTS.has(segment) && portal === 'partner') {

    return <Navigate to={engagementPath()} replace />;

  }

  if (segment === 'my-number' && portal !== 'partner') {

    return <Navigate to={engagementPath()} replace />;

  }



  if (segment && !navRoutes.some((item) => item.segment === segment)) {

    return <Navigate to={engagementPath()} replace />;

  }



  const page = PAGE_BY_SEGMENT[segment] ?? PAGE_BY_SEGMENT[''];

  return (

    <EngagementScopeProvider>

      <EngagementShell key={location.pathname}>{page}</EngagementShell>

    </EngagementScopeProvider>

  );

}



export function EngagementRoutes() {

  const navRoutes = getEngagementNavRoutes(getEngagementPortal());

  return (

    <EngagementScopeProvider>

    <Routes>

      <Route path="voice-call" element={<VoiceCall />} />

      <Route path="staff" element={<Navigate to={staffAvailabilityRedirect()} replace />} />

      <Route path="staff-availability" element={<Navigate to={staffAvailabilityRedirect()} replace />} />

      <Route path="slots" element={<Navigate to={staffAvailabilityRedirect()} replace />} />

      <Route element={<EngagementShell />}>

        {navRoutes.map((item) =>

          item.segment === '' ? (

            <Route key="home" index element={PAGE_BY_SEGMENT['']} />

          ) : (

            <Route key={item.segment} path={item.segment} element={PAGE_BY_SEGMENT[item.segment]} />

          ),

        )}

        {Object.entries(ENGAGEMENT_REDIRECTS).map(([from, to]) => (

          <Route key={from} path={from} element={<Navigate to={to} replace relative="path" />} />

        ))}

        <Route path="*" element={<Navigate to="" replace relative="path" />} />

      </Route>

    </Routes>

    </EngagementScopeProvider>

  );

}



/** Standalone `npm run start:engagement` wraps routes in BrowserRouter; main App.js does not. */

export default function EngagementApp() {

  if (process.env.REACT_APP_TARGET === 'engagement') {

    return (

      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>

        <EngagementRoutes />

      </BrowserRouter>

    );

  }

  return <EngagementEmbedded />;

}


